import React from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import simpleEPS from '../../assets/images/icons/SVG/EPS94.jpg'
import dobleEPS from '../../assets/images/icons/SVG/dEPS134.jpg'
import simpleCeramica from '../../assets/images/icons/SVG/ceramica94.jpg'
import dobleCeramica from '../../assets/images/icons/SVG/dceramica134.jpg'
import simpleHormigon from '../../assets/images/icons/SVG/hormigon94.jpg'
import dobleHormigon from '../../assets/images/icons/SVG/dhormigon134.jpg'

function ResultsCalculator({limpiar, res}) {
  // console.log(res.superficie)
  return (
    <>
    { res.posible === 'Si' || res.posible2 === 'Si' ?
    <section id="results-calculator" className="px-2">
      <header className="pt-5 pb-2">
        <h1>
          <span>Resultados</span>
        </h1>
      </header>
      <section
        id="institucional__contacto"
        className="container display-form flex-no-wrap pt-10 resultados-calculadora"
        >
        <div className="col-sm-12 col-md-6 col-lg-6 style-calculadora-izquierda">
          {/* Seccion columna izquierda */}
          <div>
           <h2 className="id-section-contacto">Cargas de Cálculos</h2>
           

            <article className="md:w-1/2 rounded-lg formulario-styles">
              <p>
                Carga permanente accesoria: <span>{res.carga}kg/m²</span>
              </p>
              <p>
                Sobrecarga reglamentaria: <span>{res.sobreCarga} kg/m²</span>
              </p>
              <p>
                Carga útil: <span>{res.cargaTotal} kg/m²</span>
              </p>
            </article>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 style-calculadora-derecha">
          <div>
              <h2 className="id-section-contacto">Dimensiones de Cálculo</h2>
            <article className="md:w-1/2 rounded-lg formulario-styles">
              <p>
                Luz: <span>{res.luzOriginal} mts</span>
              </p>
              <p>
                Ancho: <span>{res.anchoOriginal} mts</span>
              </p>
              <p>
                Superficie: <span>{res?.superficie.toFixed(3)} m²</span>
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* Seccion Forjado Opcion 1 */}
      { res.posible === 'Si' ?
      <section
        id="institucional__contacto"
        className="container display-form flex-no-wrap mb-5 resultados-calculadora"
        >
        <div className="col-sm-12 col-md-6 col-lg-6 style-calculadora-izquierda">
          {/* Seccion columna izquierda */}
          <div>
           
              <h2 className="id-section-contacto">
                Características del Forjado Opción 1
              </h2>
            

            <article className="md:w-1/2 rounded-lg formulario-styles">
              <p>
                Viguetas Serie: <span>{res.row_prov?.serie}</span>
              </p>
              <p>
                Capacidad de carga del forjado: <span>{res?.cargaadmisible} kg/m²</span>
              </p>
              <p>
                Material de bovedilla: <span>{res.row_prov?.material}</span>
              </p>
              <p>
                Altura de bovedilla: <span>{res?.espesorbov} cm</span>
              </p>
              <p>
                Espesor capa: <span>{res?.espesorcapa} cm</span>
              </p>
              <p>
                Espesor total: <span>{res?.espesortotal} cm</span>
              </p>
              <p>
                Precio propio del forjado: <span>{res?.pesopropio} kg/m²</span>
              </p>
            </article>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 style-calculadora-derecha">
          <div>
            
              <h2 className="id-section-contacto">
                Cómputo Métrico de Materiales Opción 1
              </h2>
            
            <article
              id="resultados-derecha"
              className="md:w-1/2 rounded-lg formulario-styles resultados-derecha"
              >
              <p>
                {res?.cantidadvig1} Viguetas <span>de {res.luzOriginal} mts. de la serie {res.row_prov?.serie}</span>
              </p>
              { res.row_prov?.material === 'EPS' ?
                <p>
                {res?.cantidadbov1/2} Bovedillas <span>1 metro o</span> {res?.cantidadbov1} <span>de 0.50 metros</span> de {res?.espesorbov} cm
              </p> :
              <p>
                {res?.cantidadbov1} Bovedillas <span>de {res?.espesorbov} cm</span>
              </p> 
              }
              <p>
                {res?.volhomigon.toFixed(3)} m³ <span>de Hormigón H-17 (mínimo)</span>
              </p>
              <img
                className="w-100"
                src={res.row_prov2?.material === "EPS" ? simpleEPS : res.row_prov2?.material === "ceramica" ? simpleCeramica : simpleHormigon}
                alt="bovedilla-hormigon"
                />
            </article>
          </div>
        </div>
      </section> : null }

      {/* Seccion Forjado Opcion 2 */}
      { res.posible2 === 'Si' ?
      <section
      id="institucional__contacto"
      className="container display-form flex-no-wrap mb-3 resultados-calculadora"
      >
        <div className="col-sm-12 col-md-6 col-lg-6 style-calculadora-izquierda">
          {/* Seccion columna izquierda */}
          <div>
            
              <h2 className="id-section-contacto">
                Características del Forjado Opción 2
              </h2>
           

            <article className="md:w-1/2 rounded-lg formulario-styles">
              <p>
                Viguetas Serie: <span>{res.row_prov2?.serie}</span>
              </p>
              <p>
                Capacidad de carga del forjado: <span>{res?.cargaadmisible2} kg/m²</span>
              </p>
              <p>
                Material de bovedilla: <span>{res.row_prov2?.material}</span>
              </p>
              <p>
                Altura de bovedilla: <span>{res?.espesorbov2} cm</span>
              </p>
              <p>
                Espesor capa: <span>{res?.espesorcapa2} cm</span>
              </p>
              <p>
                Espesor total: <span>{res?.espesortotal2} cm</span>
              </p>
              <p>
                Precio propio del forjado: <span>{res?.pesopropio2} kg/m²</span>
              </p>
            </article>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 style-calculadora-derecha">
          <div>
            
              <h2 className="id-section-contacto">
                Cómputo Métrico de Materiales Opción 2
              </h2>
            
            <article
              id="resultados-derecha"
              className="md:w-1/2 rounded-lg formulario-styles resultados-derecha"
              >
              <p>
                {res?.cantidadvig2} Viguetas <span>de {res.luzOriginal} mts. de la serie {res.row_prov2?.serie}</span>
              </p>
              { res.row_prov2?.material === 'EPS' ?
              <p>
                {res?.cantidadbov2/2} Bovedillas <span>1 metro o</span> {res?.cantidadbov2} <span>de 0.50 metros</span> de {res?.espesorbov2} cm
              </p> :
              <p>
                {res?.cantidadbov2} Bovedillas <span>de {res?.espesorbov2} cm</span>
              </p>
              }
              <p>
                {res?.volhomigon2.toFixed(3)} m³ <span>de Hormigón H-17 (mínimo)</span>
              </p>
              <img
                className="w-100"
                src={res.row_prov2?.material === "EPS" ? dobleEPS : res.row_prov2?.material === "ceramica" ? dobleCeramica : dobleHormigon}
                alt="bovedilla-hormigon"
                />
            </article>
              

          </div>
        </div>
      </section> : null }
      <div className="container col-12 install-products-components">
      <button onClick={limpiar} className="button-resultscalculadora mt-3 mb-4 m-auto d-flex shadow">
                Nuevo cálculo
            </button>
        <div className="install-products-components">
          <div className="row advertise align-items-center">
            <div className="col-12 col-md-4 text-center ">
              <p>
                <WarningAmberIcon fontSize="large" className="icon-advertise" />
              </p>
            </div>
            <div className="col-12 col-md-8 mt-2">
              <p className="text-advertise">
                Tensolite S.A. no se responsabiliza por el uso inadecuado de
                este programa. En caso de duda consultar a un profesional
                competente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section> : null}
  </>
  )
}

export default ResultsCalculator;
